import * as React from 'react';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';
import loadScript, { URLS } from 'Jsx/Utils/loadScript';
import isTouchDevice from 'Jsx/Utils/isTouchDevice';

const Wrapper: React.FC<Partial<CourseCardProps>> = props => {
  const mountRef = React.useRef(false);
  const { children, ...rest } = props;
  const previewWrapper = React.useRef<HTMLDivElement>(null);
  const [loadingWistiaScript, setLoadingWistiaScript] = React.useState(true);

  React.useEffect(() => {
    mountRef.current = true;
    return () => {
      mountRef.current = false;
    };
  }, []);

  const loadWistia = () => {
    loadScript({ src: URLS.wistia })
      .then(() => {
        if (mountRef.current) {
          setLoadingWistiaScript(false);
        }
      })
      .catch(() => {
        if (mountRef.current) {
          setLoadingWistiaScript(false);
        }
      });
  };

  const handleKeyUp = event => {
    if (event.keyCode === 27) {
      event.stopPropagation();
    }
  };

  React.useEffect(() => {
    if (loadingWistiaScript && !isTouchDevice() && !rest.hidePreview) {
      loadWistia();
    }

    document.addEventListener('keyup', handleKeyUp);
    return () => document.removeEventListener('keyup', handleKeyUp);
  }, [loadingWistiaScript, rest.hidePreview]);

  return (
    <div
      ref={previewWrapper}
      className="CourseCardComponent relative w-full"
      data-testid="course-card-wrapper"
      // this id is used as a item "reference" in some SEO components
      id={`course-item-${rest.originalId}`}
      css={`
        @media (min-width: 1024px) {
          &:hover {
            box-shadow: 0px 4px 18px rgba(92, 84, 122, 0.14);
            transition: all ease-in 0.3s;
          }
        }
      `}
    >
      {React.Children.toArray(children).map(child =>
        React.cloneElement(child as React.ReactElement<any>, rest),
      )}
    </div>
  );
};

export default Wrapper;
